<template>
  <div style="width: 100%" class="head-span">
    <div class="message">
      <div class="heading-msg">
        <br />
        <span>
          <div class="welcome">
            <span> Welcome to the HP Workpath Apps Catalog! </span>
          </div>
          <div>
            <span class="br">
              Unlock a world of possibilities with HP and third-party apps that
              are designed to expand and evolve the capabilities of your HP
              Workpath-enabled multifunction printers<sup class="number">1</sup
              >. Check out the entire catalog of apps created to enhance
              workflows and streamline your digitization process, while securing
              confidential information. Use the Filter tab to search by country
              of availability, brand, app type, and/or industry.
            </span>
            <span class="home">
              All apps available on the Workpath platform have passed the HP
              Verification and Validation (V&V) processes to help ensure app
              security.
            </span>
          </div>
          <nobr>
            <span class="br_1">
              Contact your HP representative for information on how to purchase
              HP Workpath apps.<br />
              For assistance in finding a local HP representative, please
              complete the
              <a
                class="hprequest-link"
                href="https://app.smartsheet.com/b/form/9930b3acbbd845d8b93bad4915f43392"
                target="_blank"
              >
                HP Request Form
              </a>
            </span>
          </nobr>
        </span>
      </div>
    </div>

    <div class="exportPdf">
      <div class="featuredArea">
        <router-link to="getLinkUrl()">
          <div
            id="moveToAllSolutionsButton"
            style="color: #0096d6; border-bottom: 6px solid #0096d6"
            class="featured"
            v-on:click.prevent="allSolution($event)"
          >
            All Solutions
          </div>
        </router-link>
      </div>

      <img
        @click="
          show = 'true';
          changeOrientation('p');
          downloadPdf();
        "
        alt="Export Pdf"
        src="../assets/images/icons/pdf.png"
      />
      <b-modal
        v-model="show"
        title="Your PDF is being downloaded"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
      >
        <template v-slot:modal-footer>
          <div class="w-100" style="display: flex; justify-content: center">
            <b-button
              variant="success"
              size="sm"
              class="float-right btn"
              style="margin: 0 10px"
              @click="show = false"
            >
              Ok
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ApiSvc from "../js/ApiSvc";
import { API } from "../js/Constants.js";
import { PdfConstants } from "../js/PdfConstants.js";

export default {
  name: "export-pdf",
  data() {
    return {
      totalItems: 0,
      tableData: [],
      mode: "",
      show: false,
      variants: ["primary", "success"],
      headerBgVariant: "primary",
      headerTextVariant: "light",
      height: 0,
      width: 0,
      filterTypes: {
        country: [],
        brand: [],
        industryType: [],
        solutionType: [],
        platformType: [],
      },
    };
  },
  props: {
    request: {
      type: Object,
    },
  },
  methods: {
    allSolution(event) {
      event.target.style.color = "#0096d6";
      event.target.style.borderBottom = "6px solid #0096d6";
      document.getElementById("moveToAllSolution").style.color = "#b1b1b1";
      document.getElementById("moveToAllSolution").style.borderBottom =
        "6px solid #cccccc";
      console.log(event);
      this.$router.push(`/allSolution`);
    },

    downloadPdf() {
      this.request.paging.limit = -1;
      ApiSvc.request(["/appinfolist"], API.POST, this.request)
        .then((res) => {
          const { filteredSize } = res.data;
          const { resourceList } = res.data;
          this.totalItems = filteredSize;
          this.tableData = resourceList;
          const doc = new jsPDF(this.mode, "mm", "a4");
          const FormaDJRBase64 = PdfConstants.HPSimplifiedNormal;
          const FormaDJRBoldBase64 = PdfConstants.FormaDJRBold;
          doc.addFileToVFS("FormaDJRDisplay-Regular.ttf", FormaDJRBase64);
          doc.addFileToVFS("FormaDJRDisplay Bold.ttf", FormaDJRBoldBase64);
          doc.addFont("FormaDJRDisplay-Regular.ttf", "FormaDJR", "normal");
          doc.addFont("FormaDJRDisplay Bold.ttf", "FormaDJRBold", "bold");
          doc.setFont("FormaDJR");
          doc.setFont("FormaDJRBold");

          if (this.mode === "p") {
            this.firstPageContentPortraitMode(doc);
          }

          doc.text(`Total Results: ${this.totalItems}`, this.width - 50, 30);
          this.createAutoTable(doc);
          this.addHeaders(doc);
          if (this.tableData.length === 0 && this.mode === "p") {
            doc.text(`No data found`, this.width - 130, 70);
          } else if (this.tableData.length === 0 && this.mode === "l") {
            doc.text(`No data found`, this.width - 175, 70);
          }
          this.addFooters(doc);
          doc.save("HPAppsCatalog.pdf");
        })
        .catch(() => this.spinner--);
    },
    addFooters(doc) {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFont("FormaDJR", "normal");
      doc.setFontSize(8);
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.4);
        doc.line(
          10,
          this.height - 57 + 10,
          this.width - 10,
          this.height - 57 + 10
        );
        doc.text(
          "Page " + String(i) + " of " + String(pageCount),
          doc.internal.pageSize.width - 40,
          this.height - 57 + 15
        );
        doc.line(
          10,
          this.height - 57 + 18,
          this.width - 10,
          this.height - 57 + 18
        );
        doc.setFont("FormaDJR", "normal");
        doc.setFontSize(10);
        let d = new Date();
        doc.text(`Date: ${d.toString()}`, 15, this.height - 57 + 25);
        var text = PdfConstants.footerCopyRight;
        var lines = doc.splitTextToSize(text, this.width - 50);
        doc.text(lines, 15, this.height - 57 + 30);

        let img = this.loadImgAsBase64(PdfConstants.hpLogoBase64);
        doc.addImage(
          img,
          "PNG",
          this.width - 30,
          this.height - 57 + 25,
          15,
          15
        );
      }
    },
    addHeaders(doc) {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFont("FormaDJRBold", "bold");
        doc.setFontSize(20);
        doc.text("HP Apps Catalog", 15, 20);
      }
    },
    createAutoTable(doc) {
      let results = [];
      for (let i = 0; i < this.tableData.length; i++) {
        results.push({
          appName: this.tableData[i].name,
          description: this.tableData[i].resourceDetails.description,
          platform: this.tableData[i].resourceDetails.platformType,
          vendorName: this.tableData[i].vendorName,
        });
      }
      let columns = [
        { title: "App Name", dataKey: "appName" },
        { title: "Description", dataKey: "description" },
        { title: "Platform Type", dataKey: "platform" },
        { title: "Vendor Name", dataKey: "vendorName" },
      ];
      doc.autoTable(columns, results, {
        startY: 35,
        headStyles: {
          fillColor: [51, 122, 183],
          lineWidth: 0.2,
          lineColor: [0, 0, 0],
        },
        theme: "striped",
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.2,
        margin: {
          bottom: 50, //this decides how big your footer area will be
          top: 35, //this decides how big your header area will be.
        },
        styles: {
          valign: "middle",
          fontSize: 10,
          font: "FormaDJR",
          minCellHeight: 10,
        },
        bodyStyles: {
          lineWidth: 0.2,
          lineColor: [0, 0, 0],
        },
        rowPageBreak: "avoid",
      });
    },
    loadImgAsBase64(url) {
      let img = document.createElement("img");
      img.src = url;
      return img;
    },
    firstPageContentPortraitMode(doc) {
      var lMargin = 15;
      var rMargin = 15;
      this.width = doc.internal.pageSize.getWidth();
      this.height = doc.internal.pageSize.getHeight();
      doc.setFont("FormaDJR", "normal");
      doc.setFontSize(15);
      var lines = doc.splitTextToSize(
        PdfConstants.paragraph1,
        this.width - lMargin - rMargin
      );
      doc.text(lines, lMargin, 35);
      doc.setFont("FormaDJR", "normal");
      doc.setFontSize(15);
      lines = doc.splitTextToSize(
        PdfConstants.paragraph2,
        this.width - lMargin - rMargin
      );

      doc.text(lines, lMargin, 45);
      doc.setFont("FormaDJR", "normal");
      doc.setFontSize(15);
      lines = doc.splitTextToSize(
        PdfConstants.paragraph3,
        this.width - lMargin - rMargin
      );
      doc.text(lines, lMargin, 75);
      doc.setFont("FormaDJR", "normal");
      lines = doc.splitTextToSize(
        PdfConstants.paragraph4,
        this.width - lMargin - rMargin
      );
      doc.text(lines, lMargin, 95);
      doc.addPage();
    },
    changeOrientation(value) {
      this.mode = value;
    },
  },
};
</script>
<style scoped>
.heading-msg {
  width: 60%;
  margin-left: 1.7%;
  font-size: 98%;
  padding: 0px 0px 0px 1px;
  color: #202329;
  font-family: "FormaDJR";
  text-align: left;
}

.hprequest-link {
  text-decoration: underline;
  display: inline-block;
  width: 113px;
}

.next-line {
  display: block;
}
.home {
  display: block;
  margin-bottom: 0.5em;
  text-align: justify;
  width: 160%;
}

@media screen and (max-width: 1024px) {
  .next-line {
    display: none;
  }
}

img {
  width: 50px;
  height: 50px;
}
.head-span {
  font-family: "FormaDJR";
}
.exportPdf {
  margin-right: 3%;
  margin-bottom: 20px;
  width: fit-content;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  margin-top: 20px;
}
.featuredArea {
  display: flex;
  font-family: "FormaDJR";
}
.featuredArea a {
  color: #b1b1b1;
}
.featuredArea a:hover {
  text-decoration: none;
}

.featuredArea div#moveToAllSolutionsButton {
  padding: 10px 25px;
  border-bottom: 6px solid #cccccc;
  font-family: "FormaDJR";
  font-size: 20px;
}

.container {
  font-family: "FormaDJR";
  display: flex;
  justify-content: center;
  align-items: center;
}

.selected {
  border: solid #007bff 5px;
}

p {
  margin: auto;
}
.btn {
  width: 6rem;
  height: 2rem;
}
.number {
  font-size: 11px;
}
.br {
  display: block;
  margin-bottom: 0.5em;
  line-height: 1.1em;
  text-align: justify;
  width: 160%;
}
.br_1 {
  display: block;
  line-height: 1.1em;
}
.welcome {
  margin-bottom: 0.5em;
}
.pdf-head {
  font-family: "FormaDJR";
}
</style>
